import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { RequiredInput } from './input'

export type Address = {
  street: string;
  house: string;
  postalAndCity: string;
}

export interface AddressFormProps {
  value: Address;
  onChange: (value: Address) => void;
  showError?: boolean;
  onErrorChange: (error: boolean) => void;
  disabled?: boolean;
}

export const AddressForm: React.FC<AddressFormProps> = function (props) {
  const { value: address, onChange, showError, onErrorChange, disabled = false } = props
  const [streetError, setStreetError] = useState(true)
  const [houseError, setHouseError] = useState(true) 
  const [cityError, setCityError] =useState(true)

  function validate (address: Address): boolean {
    setStreetError(!address.street)
    setHouseError(!address.house)
    setCityError(!address.postalAndCity)
    const error = !address.street || !address.house || !address.postalAndCity
    onErrorChange(error)
    return error
  }

  function update (key: string, value: any): void {
    const newAddress = {
      ...address,
      [key]: value
    }

    validate(newAddress)
    onChange(newAddress)
  }

  return (
    <Grid container spacing={2} direction="column" alignContent="stretch">
      <Grid item xs>
        <RequiredInput disabled={disabled} label="Ulica" onChange={value => update('street', value)} value={address.street} error={showError && streetError}/>
      </Grid>
      <Grid item xs>
        <RequiredInput disabled={disabled} label="Numer domu/mieszkania" onChange={value => update('house', value)} value={address.house} error={showError && houseError} />
      </Grid>
      <Grid item xs>
        <RequiredInput disabled={disabled} label="Kod pocztowy i miejscowość" onChange={value => update('postalAndCity', value)} value={address.postalAndCity} error={showError && cityError} />
      </Grid>
    </Grid>
  )
}
